export var cibVerizon = ["32 32", "<path d='M24.401 0h4.932v0.005l-15.099 31.995h-4.021l-7.547-16h4.969l4.599 9.781z'/>"];
